var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('hsHeader'),_c('div',{staticClass:"layout"},[_c('transition',{attrs:{"name":"fade","duration":100}},[_c('router-view')],1)],1),_c('hsFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }